<template>
  <vueMain>
    <div slot="title">
      <b-row>
        <b-col lg="6"><span class="h3">Test</span></b-col>
        <b-col lg="6" class="text-right">Puedes poner html en el slot</b-col>
      </b-row>
    </div>
    <div data-trackname="test" class="component component-test">
      <b-row>
        <b-col lg="9">
          <div class="component component-kpis">
            <Kpicontainer></Kpicontainer>
            <!-- <Kpicontainer area="traffic"></Kpicontainer> -->
          </div>
        </b-col>
        <b-col lg="3">
          <b-card>
            <Donut val="70" units="%"></Donut>
            <h5 class="donut_subtitle">{{ $t('TestItems.table.title') }}</h5>
          </b-card>
        </b-col>
      </b-row>
      <b-card class="mt-4">
        <div slot="header">
          <h3>{{ $t("TestItems.header") }}</h3>
          <b-btn data-trackname="itemsListBtnNewItem" v-b-modal.NewItemModal variant="primary" class="card-header-button">
            {{ $t("TestItems.new_item") }} <i class="fa fa-plus"></i>
          </b-btn>
        </div>
        <Table
          ref="table"
          :columns="columns"
          url="testitems/"
          :options="options">
        </Table>
      </b-card>
      <NewItemModal id="myItemModal" @newItem="refresh"></NewItemModal>
    </div>
  </vueMain>
</template>

<script>
import spect from '@/components/Pages/Index/tableItemsT.js';
import NewItemModal from '@/components/Pages/Index/NewItemModal';

import Table from '@/components/Modules/Table/Table.vue';
import Buttons from '@/components/Modules/Table/TableButtons.vue';
import vueMain from '@/components/Layout/Main.vue';
import Kpicontainer from '@/components/Modules/Kpi/Kpicontainer.vue';
import Donut from '@/components/Modules/Misc/Donut.vue';

export default {
  name: 'TestItems',
  components: {
    NewItemModal,
    Table,
    Buttons,
    vueMain,
    Kpicontainer,
    Donut
  },
  i18n: {
    messages: {
      en: {
        TestItems: {
          header: 'Items List',
          new_item: 'New Item',
          table: {
            title: 'Title'
          }
        }
      },
      es: {
        TestItems: {
          header: 'Lista de objetos',
          new_item: 'Añadir objeto',
          table: {
            title: 'Título'
          }
        }
      }
    }
  },
  data: function () {
    return this.getSpect();
  },
  methods: {
    refresh: function () {
      this.$refs.table.refresh();
    },
    getSpect () {
      return spect;
    }
  },
  mounted: function () {}
};
</script>
<style>
td {
  cursor: pointer;
  cursor: hand;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Test/Test.vue